import React, { useState } from "react";
import { TeamAPI } from "../../../services/api";
import iconLogo from "../../../assets/icon-logo.png";
interface Team {
  id: number;
  team_id: string;
  team_name: string;
  profile_status: string;
  [key: string]: any;
}

interface SubmitForApprovalStatusProps {
  team: Team;
  onUpdate: () => void;
}

const SubmitForApprovalStatus: React.FC<SubmitForApprovalStatusProps> = ({
  team,
  onUpdate,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmitApplication = async () => {
    setLoading(true);
    try {
      // API call to submit team for approval
      const response = await TeamAPI.submitForApproval(team.team_id);
      console.log("Team submitted for approval:", response);

      onUpdate(); // Refresh team data to show updated status
    } catch (error: any) {
      console.error("Error submitting for approval:", error);
      alert(
        error.message || "Failed to submit for approval. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const isAlreadySubmitted = team.profile_status === "complete";

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="text-center py-8">
        {/* Icon/Image placeholder - you can replace with actual icon */}
        <div className="w-20 mx-auto flex items-center justify-center">
          <img src={iconLogo} className="w-full" />
        </div>

        <p className="text-lg font-semibold text-gray-900 mb-2">
          Your team is ready to apply for final approval
        </p>

        {isAlreadySubmitted ? (
          <div className="space-y-2">
            <p className="text-sm text-green-600 mb-4">
              ✓ Your application has been submitted successfully
            </p>
            <button
              disabled
              className="w-full bg-gray-400 text-white py-3 px-6 rounded-lg font-medium cursor-not-allowed"
            >
              Application Submitted
            </button>
          </div>
        ) : (
          <div className="space-y-2">
            <p className="text-sm text-gray-600 mb-4">
              All requirements are complete. Submit your team for final review.
            </p>
            <button
              onClick={handleSubmitApplication}
              disabled={loading}
              className="w-full bg-gray-800 text-white py-3 px-6 rounded-lg hover:bg-gray-700 transition-colors font-medium disabled:opacity-50"
            >
              {loading ? "Submitting..." : "Submit application"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubmitForApprovalStatus;
